<label [for]="vm.name">
  @if (vm.label) {
    <span class="label">{{ vm.label }}</span>
  }

  <ng-content select="[label-help]"></ng-content>

  <section
    class="holder mt-8"
    [class.error-box]="vm.error"
    [class.success-box]="vm.success"
    [class.keyboard-focus]="showKeyboardFocus"
  >
    <ng-content select="[icon-start]" />
    <input
      #input
      qmEncrypt
      (ngModelChange)="writeValue($event)"
      [placeholder]="vm.placeHolder"
      [ngModel]="value"
      [id]="vm.name"
      [attr.name]="vm.name"
      [disabled]="disabled"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
      [tabIndex]="tabbable() ? 0 : -1"
      type="text"
      class="body"
      autocomplete="off"
      [attr.data-testid]="vm.dataTestId"
      [attr.maxlength]="vm.maxlength ?? null"
      (keydown)="keyDown($event)"
    />
    <ng-content select="[icon-end]" />
  </section>
</label>
